import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=f0b1f08a&scoped=true"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"
import style0 from "./InputRadio.vue?vue&type=style&index=0&id=f0b1f08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b1f08a",
  null
  
)

export default component.exports